require('./helpers/bundle-manifest').register(JSON.parse("{\"53E04\":\"index.2f4cc81b.js\",\"5hZKS\":\"auto.c27c9abb.js\",\"8oehb\":\"index.783f2ca8.css\"}"));